var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import noop from "lodash/noop";
import * as React from "react";
export var Context = React.createContext({
  base: "",
  parentPath: "",
  resolve: function resolve(data) {
    return data;
  },
  requestOptions: {},
  onError: noop
});

var RestfulReactProvider =
/** @class */
function (_super) {
  __extends(RestfulReactProvider, _super);

  function RestfulReactProvider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RestfulReactProvider.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        value = __rest(_a, ["children"]);

    return React.createElement(Context.Provider, {
      value: __assign({
        onError: noop,
        resolve: function resolve(data) {
          return data;
        },
        requestOptions: {},
        parentPath: ""
      }, value)
    }, children);
  };

  return RestfulReactProvider;
}(React.Component);

export default RestfulReactProvider;
export var RestfulReactConsumer = Context.Consumer;